import { AiPredictionBox } from './annotation.types';

/**
 * Reads backend-provided anomaly detection fields off a raw feedback row
 * (AnomalyFound / Coords / BlobSize / Threshold / ModelID / PredictionType)
 * and turns them into read-only overlay boxes. Defects (Classification per
 * anomaly) are matched to Coords by index, since both arrays are produced
 * in the same order by the backend. Returns [] when the row has no anomaly
 * data so callers can use length to decide whether to show the UI.
 */
export function getAiPredictionBoxes(item: any): AiPredictionBox[] {
  const coords = item?.['Coords'];
  if (!item?.['AnomalyFound'] || !Array.isArray(coords)) {
    return [];
  }
  const defects = Array.isArray(item['Defects']) ? item['Defects'] : [];
  return coords
    .filter((c: any) => Array.isArray(c) && c.length === 4 && c.every((n: any) => typeof n === 'number'))
    .map((c: number[], index: number) => {
      const classification = defects[index]?.['Classification'];
      return {
        x1: c[0],
        y1: c[1],
        x2: c[2],
        y2: c[3],
        blobSize: item['BlobSize'],
        threshold: item['Threshold'],
        modelId: item['ModelID'],
        predictionType: item['PredictionType'],
        label: classification?.['Label'],
        probability: classification?.['Probability'],
        confidence: classification?.['Confidence'],
        suggestion: classification?.['Suggestion'],
      };
    });
}
